import angular from 'angular';
import selectContactType from './selectContactType';
import './style.scss';

export default angular
  .module('components.selectContactType', [])
  .component('selectContactType', selectContactType).name;
